import styled from 'styled-components';

import { getPurpurColor, getPurpurShadow } from '@telialt/common-theme/src/purpurSelectors';

import { NAVIGATION_MAIN_BAR_HEIGHT } from '../../constants';

export const HeaderSkeleton = styled.header`
    z-index: 1049;
    position: relative;
    background-color: ${getPurpurColor('functionalWhite')};
    box-shadow: ${getPurpurShadow('sm')};
    height: ${NAVIGATION_MAIN_BAR_HEIGHT}px;
`;
